// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"968b9cf4","455":"168fdbff","977":"514d8870"}[chunkId] + ".chunk.js";
};